import React, { memo } from "react";
import { useTranslation, Trans } from "react-i18next";
import styled from "styled-components";
import { LocationSearchBox, IconIdea, Alert } from "@talentbait/shared-components";

import DraftCampaignStepLayout from "./DraftCampaignStepLayout";

const LocationTooltip = styled.span`
  b {
    font-weight: bold;
  }
`;

const DraftCampaignLocationStep = ({
  state,
  onChange,
  onSubmit,
  onSkip,
  loading,
  errors,
  googleApiKey,
  namespace,
  ...rest
}) => {
  const { t } = useTranslation();

  // TODO: look into locationsearch debounce and reenable once fixed
  return (
    <DraftCampaignStepLayout
      header={<Trans>Define who you want to see your ads</Trans>}
      subHeader={t("Choose where you want to generate engagement.")}
      onSubmit={onSubmit}
      onSkip={onSkip}
      loading={loading}
      errors={errors}
      namespace={namespace}
      info={
        <>
          <Alert
            Icon={IconIdea}
            title={t("Remote Positions")}
            message={t(
              "For remote positions, you don't necessarily choose your company's headquarters as the location, but instead specify larger regions."
            )}
          />
          {2 < state.locations.length && (
            <Alert
              Icon={IconIdea}
              title={t("Number of Locations")}
              message={t(
                "Please note, that there are additional costs when selecting more than two locations"
              )}
            />
          )}
        </>
      }
      {...rest}
    >
      <LocationSearchBox
        googleApiKey={googleApiKey}
        onSelect={onChange}
        id="locations"
        values={state.locations}
        label={t("Location")}
        placeholder={t("Add location")}
        error={errors?.locations}
        debounce={false}
        log-namespace={namespace}
        tooltip={
          <Trans parent={LocationTooltip}>
            Two cities and one county is included in the campaign budget and there is{" "}
            <b>no extra cost</b>. The combination of locations is fully customizable.
          </Trans>
        }
      />
    </DraftCampaignStepLayout>
  );
};

export default memo(DraftCampaignLocationStep);
